import IconBase from "./IconBase";

const PositionIcon = props => (
  <IconBase {...props}>
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="m11.185 4.518 5.768 2.524a.5.5 0 0 1 0 .916l-5.768 2.524c-.49.214-.669.27-.877.306a1.747 1.747 0 0 1-.616 0c-.208-.037-.387-.092-.877-.306L3.047 7.958a.5.5 0 0 1 0-.916l5.768-2.524c.49-.214.669-.27.877-.306.209-.036.407-.036.616 0 .208.037.387.092.877.306zM17 12.5l-6.167 2.753c-.356.159-.48.2-.623.227a1.097 1.097 0 0 1-.42 0c-.143-.027-.267-.068-.623-.227L3 12.5" />
    </g>
  </IconBase>
);

export default PositionIcon;
